import React, { useEffect } from 'react'

export type IProps = Record<string, never>

const DevPage: React.FC<IProps> = () => {
    useEffect(() => {
        // Dev page component
    }, [])

    return <div>Dev1</div>
}

export default DevPage